import { defineComponent as _defineComponent } from 'vue'
import { Icons } from '@/icons/icons'
import { PropType } from 'vue'
import ContactUsCardComponent from '@/components/SupportServiceDialog/ContactUsCardComponent.vue'
import ChatOnlineCardComponent from '@/components/SupportServiceDialog/ChatOnlineCardComponent.vue'
import HelpCenterCardComponent from '@/components/SupportServiceDialog/HelpCenterCardComponent.vue'

// PROPS

export default /*#__PURE__*/_defineComponent({
  __name: 'SupportServiceDialogComponent',
  props: {
  showDialog: {
    type: Boolean as PropType<boolean>,
    default: false
  }
},
  emits: ['hide-dialog'],
  setup(__props, { emit }) {

const props = __props;



// DATA
const icon = {
  close: Icons.CLOSE
}

// EVENTS


// METHODS
function hideDialog() {
  emit('hide-dialog', false)
}

function checkIfHideDialog($event: Event) {
  const elementClicked = $event.target as HTMLElement

  if (elementClicked.classList.contains('dialog-container')) {
    hideDialog()
  }
}

return { __sfc: true,props, icon, emit, hideDialog, checkIfHideDialog, ContactUsCardComponent, ChatOnlineCardComponent, HelpCenterCardComponent }
}

})